import auth from "./apis/authentication";
import config from "./apis/config";
import stores from "./apis/stores";
import checkout from "./apis/checkout";

export const apiService = {
  auth,
  config,
  stores,
  checkout
};
